import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
let DatePicker = class DatePicker extends Vue {
    constructor() {
        super(...arguments);
        this.valueInput = this.value && this.value !== undefined ? moment(this.value).format('DD/MM/YYYY') : "";
        this.valuePicker = this.allowRange ?
            [moment(this.value).format('YYYY-MM-DD'), moment(this.endValue).format('YYYY-MM-DD')] :
            (this.value && this.value !== undefined ? moment(this.value).format('YYYY-MM-DD') : '');
        this.showMenu = false;
    }
    onValueChanged(newValue) {
        this.valueInput = this.value && this.value !== undefined ? moment(this.value).format('DD/MM/YYYY') : '';
        this.valuePicker = this.value && this.value !== undefined ? moment(this.value).format('YYYY-MM-DD') : undefined;
    }
    onClear() {
        this.$emit('input', this.asDate ? undefined : "");
    }
    onChanged() {
        let ret = this.valuePicker;
        if (ret) {
            if (!(ret instanceof Array)) {
                if (this.asDate) {
                    ret = moment(ret, 'YYYY-MM-DD').toDate();
                }
            }
            else {
                if (this.asDate) {
                    ret = [moment(ret[0], 'YYYY-MM-DD').toDate(), moment(ret[1], 'YYYY-MM-DD').toDate()];
                }
            }
        }
        this.$emit('input', ret);
        this.$emit('changed', ret);
    }
};
tslib_1.__decorate([
    Prop()
], DatePicker.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({ default: moment().format() })
], DatePicker.prototype, "endValue", void 0);
tslib_1.__decorate([
    Prop({ default: 'Fecha' })
], DatePicker.prototype, "caption", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], DatePicker.prototype, "allowRange", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], DatePicker.prototype, "outlined", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], DatePicker.prototype, "dense", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], DatePicker.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], DatePicker.prototype, "clearable", void 0);
tslib_1.__decorate([
    Prop({ default: undefined })
], DatePicker.prototype, "min", void 0);
tslib_1.__decorate([
    Prop({ default: undefined })
], DatePicker.prototype, "max", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], DatePicker.prototype, "asDate", void 0);
tslib_1.__decorate([
    Watch('value')
], DatePicker.prototype, "onValueChanged", null);
DatePicker = tslib_1.__decorate([
    Component
], DatePicker);
export default DatePicker;
